import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'lilu-server-info',
  styleUrl: 'lilu-server-info.scss',
  shadow: true,
})
export class LiluServerInfo {
  @Prop() dataIp = '';
  @Prop() dataServer = '';
  @Prop() dataVersion = '';
  @Prop() dataTemplateVersion = '';
  @Prop() dataIpShow = false;
  @Prop() dataServerShow = false;
  @Prop() dataVersionShow = false;
  @Prop() dataTemplateVersionShow = false;

  componentWillLoad() {
    const hasServerInfo = document.querySelector('lilu-server-info') !== null;

    if (hasServerInfo) {
      if (this.dataIp.length !== 0) {
        this.dataIpShow = true;
      }
      if (this.dataServer.length !== 0) {
        this.dataServerShow = true;
      }
      if (this.dataVersion.length !== 0) {
        this.dataVersionShow = true;
      }
      if (this.dataTemplateVersion.length !== 0) {
        this.dataTemplateVersionShow = true;
      }
    }
  }

  render() {
    return (
      <Host>
        <span class={`${this.dataIpShow ? 'show' : ''}`}>{this.dataIp}</span>
        <span class={`${this.dataServerShow ? 'show' : ''}`}>{this.dataServer}</span>
        <span class={`${this.dataVersionShow ? 'show' : ''}`}>{this.dataVersion}</span>
        <span class={`${this.dataTemplateVersionShow ? 'show' : ''}`}>/</span>
        <span class={`${this.dataTemplateVersionShow ? 'show' : ''}`}>{this.dataTemplateVersion}</span>
      </Host>
    );
  }
}
